// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_fq-0";
export var actionModalContentContainer = "_fq-1";
export var createTagButton = "_fq-2";
export var footerContainer = "_fq-7";
export var fullWidthDivider = "_fq-3";
export var hasCreateTagButton = "_fq-4";
export var noCreateTagButton = "_fq-5";
export var tagsContainer = "_fq-6";
export var tagsModalContentContainer = "_fq-8";